import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { PortalServiceEnum } from "@/core/services/api/interfaces/dict/PortalService";

class DictionaryEndpoint {
  public guestCountries(): Promise<AxiosResponse> {
    return $api.get("guest/countries");
  }

  public countries(): Promise<AxiosResponse> {
    return $api.get("dictionaries/countries");
  }

  public companyFeatures(): Promise<AxiosResponse> {
    return $api.get("dictionaries/company-features");
  }

  public companyIndustries(): Promise<AxiosResponse> {
    return $api.get("dictionaries/company-industries");
  }

  public onboardingStages(): Promise<AxiosResponse> {
    return $api.get("dictionaries/onboarding-stages");
  }

  public userRoles(): Promise<AxiosResponse> {
    return $api.get("dictionaries/user-roles");
  }

  public userDocumentTypes(): Promise<AxiosResponse> {
    return $api.get("dictionaries/user-document-types");
  }

  public employeeBusinessRoles(): Promise<AxiosResponse> {
    return $api.get("dictionaries/employee-business-roles");
  }

  public paymentServiceStatuses(): Promise<AxiosResponse> {
    return $api.get("dictionaries/company-payment-service-statuses");
  }

  public corporationTypes(): Promise<AxiosResponse> {
    return $api.get("dictionaries/company-corporation-types");
  }

  public companyPaymentServices(): Promise<AxiosResponse> {
    return $api.get("dictionaries/company-payment-services");
  }

  public cryptoNetworks(): Promise<AxiosResponse> {
    return $api.get("dictionaries/crypto-networks");
  }

  public fiatCurrencies(): Promise<AxiosResponse> {
    return $api.get("dictionaries/currencies/fiat");
  }

  public cryptoCurrencies(): Promise<AxiosResponse> {
    return $api.get("dictionaries/currencies/crypto");
  }

  public freeMarketSectors(
    account_id: number | string
  ): Promise<AxiosResponse> {
    return $api.get(
      `dictionaries/transaction/accounts/${account_id}/free-market-sectors`
    );
  }

  public transactionAgents(params: {
    bank_account_id?: number;
    search?: string;
  }): Promise<AxiosResponse> {
    return $api.get("dictionaries/transaction/agents", {
      params,
    });
  }

  public iban(
    iban: string,
    params: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    if (!("params" in params)) {
      params.params = {};
    }
    params.params["iban"] = iban;

    return $api.get("dictionaries/externals/iban", params);
  }

  public swift(
    swift: string,
    params: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    if (!("params" in params)) {
      params.params = {};
    }
    params.params["swift"] = swift;

    return $api.get("dictionaries/externals/swift", params);
  }

  public beneficiary(
    iban: string,
    params: AxiosRequestConfig
  ): Promise<AxiosResponse> {
    if (!("params" in params)) {
      params.params = {};
    }
    params.params["iban"] = iban;

    return $api.get("dictionaries/beneficiary", params);
  }

  public affiliateMerchant(originTransaction: number): Promise<AxiosResponse> {
    return $api.get(
      `dictionaries/affiliate-merchant-payment/${originTransaction}`
    );
  }

  public portalService(
    portalService: PortalServiceEnum
  ): Promise<AxiosResponse> {
    return $api.get(`dictionaries/externals/${portalService}`);
  }

  public portalServices(): Promise<AxiosResponse> {
    return $api.get("dictionaries/portal-services");
  }
}

export default DictionaryEndpoint;
